<template>
    <div class="tracking-order-container" v-bind="attrs">
        <p v-if="!order">Loading order...</p>
        <tracking-order v-if="order" :order="order" />
        <div v-else class="loading">
            <p>Loading</p>
        </div>
    </div>
</template>

<script>
import trackingOrder from "./tracking-order";
export default {
    name: "UserTrackingOrder",
    components: {
        trackingOrder
    },
    props: {
        accessHash: {
            type: String,
            default: ""
        },
        inPage: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            order: null,
            attrs: {
                class: {'container': this.inPage},
                style: this.inPage ? 'padding: 60px;' : ''
            }
        }
    },
    created() {
        this.getTrackingOrder();
    },
    methods: {
        getTrackingOrder() {
            const accessHash = this.accessHash || this.$route.params.accessHash;
            if (accessHash) {
                axios(`/orders/${accessHash}/tracking`).then(({data: order}) => {
                    this.order = order;
                }).catch(error => {
                    if (error.response.data.status.message == "Order not found") {
                        toastr.error("The order could not be found. Please try again or contact us for assistance.", "Error", { timeOut: 12000 });
                    } else {
                        toastr.error("Something appears to have gone wrong while processing your request. " +
                    "Please try again or contact us for assistance.", "Error", { timeOut: 12000 });
                    }
                    this.$router.push({ name: "home"});
                })
            } else {
                this.$router.push({ name: "404"});
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .tracking-order-container {
        background-color: black;

        @media(max-width: 768px) {
            padding: 20px !important;
        }

        .loading {
            background-color: rgba(0,0,0,0.8);
        }
    }
</style>
